// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { chartDiagramParentFocusTwoChild16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-chart-diagram-parent-focus-two-child': IconChartDiagramParentFocusTwoChild;
    }
}

/**
 * The icon component for the 'chartDiagramParentFocusTwoChild' icon
 */
export class IconChartDiagramParentFocusTwoChild extends IconSvg {
    public constructor() {
        super(chartDiagramParentFocusTwoChild16X16);
    }
}

registerIconSvg('icon-chart-diagram-parent-focus-two-child', IconChartDiagramParentFocusTwoChild);
export const iconChartDiagramParentFocusTwoChildTag = 'nimble-icon-chart-diagram-parent-focus-two-child';
